const styles = (theme) => ({
  root: {
    flex: '1 0 auto',
    margin: '0 40px 40px',
  },

  beforeLine: {},

  syncTo: {
    textTransform: 'uppercase',
    fontSize: 11,
    fontWeight: 600,
    color: '#7B8B99',
    letterSpacing: 1.38,
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    lineHeight: '8px',
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    margin: '0 25% 10px',

    '& $beforeLine': {
      display: 'block',
      background: '#E1E9F0',
      flexGrow: 1,
      height: 1,
      '&:first-child': {
        marginRight: 16,
        marginLeft: 0,
      },
      '&:last-child': {
        marginRight: 0,
        marginLeft: 16,
      },
    },
  },

  healthIndicator: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: 'auto',
    backgroundImage: 'linear-gradient(135deg, #1877F2 0%, #7793FF 100%)',
    border: '1px solid rgba(39,40,42,0.10)',
    boxShadow: '0 1px 2px 0 rgba(0,0,0,0.08)',
    borderRadius: 5,
    padding: '8px 12px',
    color: 'white',
    fontSize: 12,
  },

  contentBit: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',

    '& span:first-child': {
      fontWeight: 500,
      fontSize: 15,
      color: '#27282A',
      textAlign: 'left',
      lineHeight: '24px',
    },

    '& span:nth-child(2)': {
      fontSize: 14,
      color: '#7B8B99',
      textAlign: 'left',
      lineHeight: '18px',
    },
  },

  groupRoot: {
    width: 'calc(100% + 64px)',
    marginLeft: '-32px',
    marginRight: '-32px',
    marginBottom: '8px',
  },

  option: {
    display: 'block',
    textAlign: 'left',
    width: '50%',
    padding: 0,
    '&:hover': {
      '&&': {
        background: 'white',
      },
    },
  },

  onlyOption: {
    width: '100%',
  },

  optionLabel: {
    flexDirection: 'column',
    height: '100%',
  },

  optionHeader: {
    borderBottom: '1px solid rgba(155,173,188,0.30)',
    width: '100%',
    maxHeight: 120,
    padding: 16,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },

  error: {
    color: theme.palette.error.main,
    marginTop: 8,
    '& a': {
      textDecoration: 'underline',
    },
  },

  radio: {},

  serviceIcon: {
    marginRight: 16,
  },

  optionContent: {
    padding: 24,
    minHeight: 180,
    width: '100%',
    maxWidth: '560px',
  },

  svgWrapper: {
    marginBottom: 20,
    border: '2px dashed #efefef',
    padding: 10,
    borderRadius: '50%',
    '& svg': {
      display: 'block',
      width: 30,
      height: 30,
    },
  },

  disconnected: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    minHeight: 280,
  },

  field: {
    alignItems: 'flex-start',
    margin: '0 0 25px',
    width: '100%',

    '&:last-of-type': {
      margin: 0,
    },
  },
});

export default styles;
